import { LOADING, USERS } from "../actionType/userManagementType";
import { userBulkActionUrl, usersActionsUrl } from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";

export const createUser = (payload) => (dispatch) => {
  return postAuthMethod(usersActionsUrl, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const updateUser = (payload) => (dispatch) => {
  return patchAuthMethod(usersActionsUrl, payload?.id, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const deleteUser = (id) => (dispatch) => {
  return deleteAuthMethod(`${usersActionsUrl}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getAllUsers = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  const params = Object.entries(payload)
    ?.filter(([key, value]) => key !== "sort")
    .map(([key, value]) =>
      ["isActive", "role", "team"].includes(key)
        ? `${key}.equals=${value}`
        : key === "globalSearchTerm"
          ? `${key}.contains=${value}`
          : `${key}=${value}`
    )
    .join("&");

  return getAuthMethod(
    `${usersActionsUrl}?sort=${payload?.sort ? payload?.sort : "firstName,asc"}&size=10&${params}`
  )
    .then((res) => {
      dispatch({
        type: USERS,
        payload: res.data,
        count: res?.headers["x-active-count"],
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: USERS,
        payload: [],
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const userBulkAction = (payload) => (dispatch) => {
  return postAuthMethod(userBulkActionUrl, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const searchUsers = (searchKeyword) => (dispatch) => {
  return getAuthMethod(
    `${usersActionsUrl}?sort=firstName,asc&size=10${searchKeyword ? `&firstName.contains=${searchKeyword}` : ""}`
  )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};
